<template>
  <div v-if="isVisible">
    <b-alert
        :show="localDismissCountDown"
        dismissible
        :variant="variant"
        @dismissed="onDismissed"
        @dismiss-count-down="countDownChanged"
    >
      {{ message }}
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {
    dismissSecs: {
      type: Number,
      default: 3,
    },
    message: {
      type: String,
      default: "This is an alert.",
    },
    variant: {
      type: String,
      default: "warning",
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localDismissCountDown: 0,
    };
  },
  watch: {
    isVisible(newValue) {
      if (newValue) {
        this.localDismissCountDown = this.dismissSecs;
      }
    },
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.localDismissCountDown = dismissCountDown;
      if (dismissCountDown === 0) {
        this.$emit("dismissed"); // Emit an event when countdown ends
      }
    },
    onDismissed() {
      this.localDismissCountDown = 0;
      this.$emit("dismissed"); // Emit an event to notify the parent when dismissed
    },
  },
};
</script>
